export default __webpack_public_path__ + "static/bandoleiro-cfd104aea95698f10ddc9f9d15cb648a.webm";